import type { ComponentProps } from 'react';

import { cn } from '../cn';
import { commonIconClassName } from './common';

export const Lightbulb03 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M15 15.3264C17.3649 14.2029 19 11.7924 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 11.7924 6.63505 14.2029 9 15.3264V16C9 16.9319 9 17.3978 9.15224 17.7654C9.35523 18.2554 9.74458 18.6448 10.2346 18.8478C10.6022 19 11.0681 19 12 19C12.9319 19 13.3978 19 13.7654 18.8478C14.2554 18.6448 14.6448 18.2554 14.8478 17.7654C15 17.3978 15 16.9319 15 16V15.3264Z"
      className="fill-current opacity-12"
    />
    <path
      d="M9.5 22H14.5M15 15.3264C17.3649 14.2029 19 11.7924 19 9C19 5.13401 15.866 2 12 2C8.13401 2 5 5.13401 5 9C5 11.7924 6.63505 14.2029 9 15.3264V16C9 16.9319 9 17.3978 9.15224 17.7654C9.35523 18.2554 9.74458 18.6448 10.2346 18.8478C10.6022 19 11.0681 19 12 19C12.9319 19 13.3978 19 13.7654 18.8478C14.2554 18.6448 14.6448 18.2554 14.8478 17.7654C15 17.3978 15 16.9319 15 16V15.3264Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Lightbulb = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M15.5 16.874C17.0141 15.7848 18 14.0075 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 14.0075 6.98593 15.7848 8.5 16.874V18.8C8.5 19.9201 8.5 20.4802 8.71799 20.908C8.90973 21.2843 9.21569 21.5903 9.59202 21.782C10.0198 22 10.5799 22 11.7 22H12.3C13.4201 22 13.9802 22 14.408 21.782C14.7843 21.5903 15.0903 21.2843 15.282 20.908C15.5 20.4802 15.5 19.9201 15.5 18.8V16.874Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 2V3M3 12H2M5.5 5.5L4.8999 4.8999M18.5 5.5L19.1002 4.8999M22 12H21M10 13.5H14M12 13.5V18.5M15.5 16.874C17.0141 15.7848 18 14.0075 18 12C18 8.68629 15.3137 6 12 6C8.68629 6 6 8.68629 6 12C6 14.0075 6.98593 15.7848 8.5 16.874V18.8C8.5 19.9201 8.5 20.4802 8.71799 20.908C8.90973 21.2843 9.21569 21.5903 9.59202 21.782C10.0198 22 10.5799 22 11.7 22H12.3C13.4201 22 13.9802 22 14.408 21.782C14.7843 21.5903 15.0903 21.2843 15.282 20.908C15.5 20.4802 15.5 19.9201 15.5 18.8V16.874Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const MicrophoneOff01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9 12C9 13.6569 10.3431 15 12 15C12.8291 15 13.5796 14.6637 14.1226 14.12L9 9V12Z"
      className="fill-current opacity-12"
    />
    <path
      d="M15 9.4V5C15 3.34315 13.6569 2 12 2C10.8224 2 9.80325 2.67852 9.3122 3.66593M12 19V22M12 19C8.13401 19 5 15.866 5 12V10M12 19C15.866 19 19 15.866 19 12V10M8 22H16M2 2L22 22M12 15C10.3431 15 9 13.6569 9 12V9L14.1226 14.12C13.5796 14.6637 12.8291 15 12 15Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Microphone01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9 5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5V12C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12V5Z"
      className="fill-current opacity-12"
    />
    <path
      d="M19 10V12C19 15.866 15.866 19 12 19M5 10V12C5 15.866 8.13401 19 12 19M12 19V22M8 22H16M12 15C10.3431 15 9 13.6569 9 12V5C9 3.34315 10.3431 2 12 2C13.6569 2 15 3.34315 15 5V12C15 13.6569 13.6569 15 12 15Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const PlayCircle = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9.5 8.96536C9.5 8.48808 9.5 8.24943 9.59974 8.11621C9.68666 8.0001 9.81971 7.92746 9.96438 7.91713C10.1304 7.90527 10.3311 8.03432 10.7326 8.29242L15.4532 11.3271C15.8016 11.551 15.9758 11.663 16.0359 11.8054C16.0885 11.9298 16.0885 12.0702 16.0359 12.1946C15.9758 12.337 15.8016 12.449 15.4532 12.673L10.7326 15.7076C10.3311 15.9657 10.1304 16.0948 9.96438 16.0829C9.81971 16.0726 9.68666 16 9.59974 15.8839C9.5 15.7506 9.5 15.512 9.5 15.0347V8.96536Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-none stroke-current"
    />
    <path
      d="M9.5 8.96533C9.5 8.48805 9.5 8.24941 9.59974 8.11618C9.68666 8.00007 9.81971 7.92744 9.96438 7.9171C10.1304 7.90525 10.3311 8.03429 10.7326 8.29239L15.4532 11.3271C15.8016 11.551 15.9758 11.663 16.0359 11.8054C16.0885 11.9298 16.0885 12.0702 16.0359 12.1946C15.9758 12.337 15.8016 12.449 15.4532 12.6729L10.7326 15.7076C10.3311 15.9657 10.1304 16.0948 9.96438 16.0829C9.81971 16.0726 9.68666 15.9999 9.59974 15.8838C9.5 15.7506 9.5 15.512 9.5 15.0347V8.96533Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Voicemail = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M6 16C8.20914 16 10 14.2091 10 12C10 9.79086 8.20914 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16Z"
      className="fill-current opacity-12"
    />
    <path
      d="M18 16C20.2091 16 22 14.2091 22 12C22 9.79086 20.2091 8 18 8C15.7909 8 14 9.79086 14 12C14 14.2091 15.7909 16 18 16Z"
      className="fill-current opacity-12"
    />
    <path
      d="M6 16C8.20914 16 10 14.2091 10 12C10 9.79086 8.20914 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16Z"
      className="fill-none stroke-current"
    />
    <path
      d="M18 16C20.2091 16 22 14.2091 22 12C22 9.79086 20.2091 8 18 8C15.7909 8 14 9.79086 14 12C14 14.2091 15.7909 16 18 16Z"
      className="fill-none stroke-current"
    />
    <path
      d="M6 16L18 16M6 16C8.20914 16 10 14.2091 10 12C10 9.79086 8.20914 8 6 8C3.79086 8 2 9.79086 2 12C2 14.2091 3.79086 16 6 16ZM18 16C20.2091 16 22 14.2091 22 12C22 9.79086 20.2091 8 18 8C15.7909 8 14 9.79086 14 12C14 14.2091 15.7909 16 18 16Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Play = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M5 4.98963C5 4.01847 5 3.53289 5.20249 3.26522C5.37889 3.03203 5.64852 2.88773 5.9404 2.8703C6.27544 2.8503 6.67946 3.11965 7.48752 3.65835L18.0031 10.6687C18.6708 11.1139 19.0046 11.3364 19.1209 11.6169C19.2227 11.8622 19.2227 12.1378 19.1209 12.3831C19.0046 12.6636 18.6708 12.8862 18.0031 13.3313L7.48752 20.3417C6.67946 20.8804 6.27544 21.1497 5.9404 21.1297C5.64852 21.1123 5.37889 20.968 5.20249 20.7348C5 20.4671 5 19.9815 5 19.0104V4.98963Z"
      className="fill-current opacity-12"
    />
    <path
      d="M5 4.98963C5 4.01847 5 3.53289 5.20249 3.26522C5.37889 3.03203 5.64852 2.88773 5.9404 2.8703C6.27544 2.8503 6.67946 3.11965 7.48752 3.65835L18.0031 10.6687C18.6708 11.1139 19.0046 11.3364 19.1209 11.6169C19.2227 11.8622 19.2227 12.1378 19.1209 12.3831C19.0046 12.6636 18.6708 12.8862 18.0031 13.3313L7.48752 20.3417C6.67946 20.8804 6.27544 21.1497 5.9404 21.1297C5.64852 21.1123 5.37889 20.968 5.20249 20.7348C5 20.4671 5 19.9815 5 19.0104V4.98963Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const PauseCircle = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      className="fill-current opacity-12"
    />
    <path
      d="M9.5 15V9M14.5 15V9M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Phone02 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M9 2H15V3.4C15 3.96005 15 4.24008 14.891 4.45399C14.7951 4.64215 14.6422 4.79513 14.454 4.89101C14.2401 5 13.9601 5 13.4 5H10.6C10.0399 5 9.75992 5 9.54601 4.89101C9.35785 4.79513 9.20487 4.64215 9.10899 4.45399C9 4.24008 9 3.96005 9 3.4V2Z"
      className="fill-current opacity-12"
    />
    <path
      d="M15 2V3.4C15 3.96005 15 4.24008 14.891 4.45399C14.7951 4.64215 14.6422 4.79513 14.454 4.89101C14.2401 5 13.9601 5 13.4 5H10.6C10.0399 5 9.75992 5 9.54601 4.89101C9.35785 4.79513 9.20487 4.64215 9.10899 4.45399C9 4.24008 9 3.96005 9 3.4V2M8.2 22H15.8C16.9201 22 17.4802 22 17.908 21.782C18.2843 21.5903 18.5903 21.2843 18.782 20.908C19 20.4802 19 19.9201 19 18.8V5.2C19 4.07989 19 3.51984 18.782 3.09202C18.5903 2.71569 18.2843 2.40973 17.908 2.21799C17.4802 2 16.9201 2 15.8 2H8.2C7.0799 2 6.51984 2 6.09202 2.21799C5.71569 2.40973 5.40973 2.71569 5.21799 3.09202C5 3.51984 5 4.0799 5 5.2V18.8C5 19.9201 5 20.4802 5.21799 20.908C5.40973 21.2843 5.71569 21.5903 6.09202 21.782C6.51984 22 7.07989 22 8.2 22Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Phone01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M5 5.2C5 4.0799 5 3.51984 5.21799 3.09202C5.40973 2.71569 5.71569 2.40973 6.09202 2.21799C6.51984 2 7.0799 2 8.2 2H15.8C16.9201 2 17.4802 2 17.908 2.21799C18.2843 2.40973 18.5903 2.71569 18.782 3.09202C19 3.51984 19 4.07989 19 5.2V18.8C19 19.9201 19 20.4802 18.782 20.908C18.5903 21.2843 18.2843 21.5903 17.908 21.782C17.4802 22 16.9201 22 15.8 22H8.2C7.0799 22 6.51984 22 6.09202 21.782C5.71569 21.5903 5.40973 21.2843 5.21799 20.908C5 20.4802 5 19.9201 5 18.8V5.2Z"
      className="fill-current opacity-12"
    />
    <path
      d="M12 17.5H12.01M8.2 22H15.8C16.9201 22 17.4802 22 17.908 21.782C18.2843 21.5903 18.5903 21.2843 18.782 20.908C19 20.4802 19 19.9201 19 18.8V5.2C19 4.07989 19 3.51984 18.782 3.09202C18.5903 2.71569 18.2843 2.40973 17.908 2.21799C17.4802 2 16.9201 2 15.8 2H8.2C7.0799 2 6.51984 2 6.09202 2.21799C5.71569 2.40973 5.40973 2.71569 5.21799 3.09202C5 3.51984 5 4.0799 5 5.2V18.8C5 19.9201 5 20.4802 5.21799 20.908C5.40973 21.2843 5.71569 21.5903 6.09202 21.782C6.51984 22 7.07989 22 8.2 22ZM12.5 17.5C12.5 17.7761 12.2761 18 12 18C11.7239 18 11.5 17.7761 11.5 17.5C11.5 17.2239 11.7239 17 12 17C12.2761 17 12.5 17.2239 12.5 17.5Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const SkipForward = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M5 7.329C5 6.2633 5 5.73045 5.21846 5.45678C5.40845 5.21876 5.69654 5.0803 6.00108 5.08063C6.35125 5.08101 6.76734 5.41387 7.59951 6.07961L13.4383 10.7506C13.9721 11.1777 14.239 11.3912 14.3357 11.6492C14.4204 11.8754 14.4204 12.1246 14.3357 12.3508C14.239 12.6088 13.9721 12.8223 13.4383 13.2494L7.59951 17.9204C6.76734 18.5861 6.35125 18.919 6.00108 18.9194C5.69654 18.9197 5.40845 18.7812 5.21846 18.5432C5 18.2696 5 17.7367 5 16.671V7.329Z"
      className="fill-current opacity-12"
    />
    <path
      d="M19 5V19M7.59951 17.9204L13.4383 13.2494C13.9721 12.8223 14.239 12.6088 14.3357 12.3508C14.4204 12.1246 14.4204 11.8754 14.3357 11.6492C14.239 11.3912 13.9721 11.1777 13.4383 10.7506L7.59951 6.07961C6.76734 5.41387 6.35125 5.081 6.00108 5.08063C5.69654 5.0803 5.40845 5.21876 5.21846 5.45677C5 5.73045 5 6.2633 5 7.329V16.671C5 17.7367 5 18.2695 5.21846 18.5432C5.40845 18.7812 5.69654 18.9197 6.00108 18.9194C6.35125 18.919 6.76734 18.5861 7.59951 17.9204Z"
      className="fill-none stroke-current"
    />
  </svg>
);

export const Keyboard01 = ({ className, ...props }: ComponentProps<'svg'>) => (
  <svg className={cn(commonIconClassName, className)} viewBox="0 0 24 24" {...props}>
    <path
      d="M2 9.2C2 8.0799 2 7.51984 2.21799 7.09202C2.40973 6.71569 2.71569 6.40973 3.09202 6.21799C3.51984 6 4.07989 6 5.2 6H18.8C19.9201 6 20.4802 6 20.908 6.21799C21.2843 6.40973 21.5903 6.71569 21.782 7.09202C22 7.51984 22 8.0799 22 9.2V14.8C22 15.9201 22 16.4802 21.782 16.908C21.5903 17.2843 21.2843 17.5903 20.908 17.782C20.4802 18 19.9201 18 18.8 18H5.2C4.0799 18 3.51984 18 3.09202 17.782C2.71569 17.5903 2.40973 17.2843 2.21799 16.908C2 16.4802 2 15.9201 2 14.8V9.2Z"
      className="fill-current opacity-12"
    />
    <path
      d="M6 10H6.01M8 14H8.01M10 10H10.01M12 14H12.01M14 10H14.01M16 14H16.01M18 10H18.01M5.2 18H18.8C19.9201 18 20.4802 18 20.908 17.782C21.2843 17.5903 21.5903 17.2843 21.782 16.908C22 16.4802 22 15.9201 22 14.8V9.2C22 8.0799 22 7.51984 21.782 7.09202C21.5903 6.71569 21.2843 6.40973 20.908 6.21799C20.4802 6 19.9201 6 18.8 6H5.2C4.07989 6 3.51984 6 3.09202 6.21799C2.71569 6.40973 2.40973 6.71569 2.21799 7.09202C2 7.51984 2 8.07989 2 9.2V14.8C2 15.9201 2 16.4802 2.21799 16.908C2.40973 17.2843 2.71569 17.5903 3.09202 17.782C3.51984 18 4.0799 18 5.2 18Z"
      className="fill-none stroke-current"
    />
  </svg>
);
